
<template>
  <div id="about">
    <div class="banner">
      <!-- 导航 -->
      <NavCustom></NavCustom>
    </div>
    <div class="history_panel">
      <div class="title"><span>中设介绍</span></div>
      <div class="history_content" :class="isAllHistory ? 'history' : ''">
        <p>
          中设集团采用多元化业务架构，以集团为核心，引领中设国
          际会展集团、中设文旅集团、中设创意展览及京合智库四大板块
          发展，业务涵盖会展服务、旅游服务、数据技术、文化创意、智
          慧平台、战略咨询、教育培训等。中设国际会展集团旗下有中设
          明德会展、中设致和会展、中设数据技术及中设花木城会展四家
          子公司;中设文旅集团旗下有中设国礼文化、中亚教育科技及今
          市网络技术三家子公司。
        </p>
        <p>
          中设集团以“明德、致和、尚礼、博学”为核心价值观，致
          力于打造国内领先、国际知名的“会展+文旅”产业生态平台。坚
          持市场化、专业化、国际化、品牌化、信息化的发展方向，积极
          倡导绿色、低碳、环保的可持续发展理念，通过模式创新与多元
          拓展，不断巩固核心竞争力。志在汇聚专业人才、构建卓越管理
          体系，成为现代服务业企业新标杆。
        </p>
        <p>
          中设国际会展集团荣膺全国百强展览主办机构、长三角会展
          业领军企业、境内办展机构前 30 强、安徽省现代服务业企业 30
          强、安徽省民营文化企业 100 强、安徽省非公经济先进单位、合
          肥市优秀民营企业、合肥市会展行业先进集体等多项荣誉;在迪
          拜世博会、全国双创活动周、国家网络安全宣传周、中国高校科
          交会、中国航天日中得到主办方高度赞扬;在中国花卉博览会、
          世界园艺博览会中荣获金奖;在全国体育大会、中国金鸡百花电
          影节中荣获优秀组织奖;文旅会、坚果展、年货节、苗交会、加
          盟展、新环会、渔博会、社博会等多个大型会展活动得到了社会各界的广泛好评。举办的会展项目类别涉及农林牧渔、工业科技、
          文旅教体、食品饮料、日用消费、医疗健康、安全应急、能源环
          保等。已举办各类展会超 300 场，展览面积近 700 万平方米，服
          务专业观众人数超 1000 万人。中设会展集团运营的中国中部花木
          城场馆，是集“展览、交易、科普、旅游”四大功能为一体的综
          合性苗木花卉交易市场。其中中国中部花木城会展中心占地面积 约 190
          亩，由三个场馆组成，建筑面积高达 3.2 万m²，场馆配备
          专有会议室、贵宾厅、可容纳 400 人的报告厅。
        </p>
        <p>
          中设文旅集团以文旅产业全链条服务为核心，主业务聚焦三
          大方向:一是文旅项目开发与运营，涵盖旅游项目策划、乡村旅
          游资源开发，承接景区、城市公园及乡村休闲业态的管理运营;
          二是文旅综合配套服务，提供品牌策划、智慧旅游搭建、文创产
          品开发等增值服务;三是关联业态支撑，布局农业服务、数字创
          意等业务，为文旅项目落地提供全维度保障。聚焦实体项目落地
          与产业升级赋能，是全域文旅领域的实践型综合服务商。中设文
          旅集团自主研发的文创系列产品，获得中国百佳旅游商品、中国
          特色旅游商品、安徽特色旅游商品、合肥旅游必购商品等称号。
        </p>
        <p>
          中设创意展览持有中设创意产业园，位于合肥市经济技术开 发区天都路 129
          号，占地面积 28 亩。作为中设集团“会展+文旅”
          战略的重要空间载体，不仅服务于集团内部创新，也面向外部优
          质企业开放。旨在打造一个集企业孵化、创意研发、产业协作与
          展示交流于一体的多功能复合空间。其长远目标是成为全省乃至
          全国范围内，具有知名度和影响力的文化创意与数字科技融合发
          展的产业集聚地之一，为文旅事业发展注入新活力。
        </p>
        <p>
          京合智库是由来自北京、合肥等地的科技、经管、法学等领
          域专家及行业领军人员共同组建的科技型、数字化前沿智库，旨
          在商务决策咨询、行业政策研究、区域发展规划、智慧型咨询顾
          问服务、数据资产管理与文旅项目运营等领域打造全国一流的智
          库型组织。公司以专业研究为根基、以系统性解决方案为核心，
          为政府部门及行业企业提供“专业研究 + 资源整合”的全流程定
          制服务。立足合肥，辐射全国，面向全球，致力于汇聚高端专家
          资源，开展高水平项目研发，聚焦数字科技开发与应用，以创新
          运营模式为社会提供高质量智库服务，为安徽“三地一区”建设
          及区域一体化战略的实施，提供强大的智力与资源支持。智库专
          家曾经或现就职于中央国家机关，知名大学及研究院，知名律所，
          京东集团、携程集团与拼多多集团等国内一流企业，曾为芜湖市、
          安庆市编制区域经济社会发展规划及文旅规划。
        </p>
        <p>
          今市——文旅生态圈，是中设集团斥资千万、全自主研发的
          文旅产业互联网平台。现已全面上线安卓、iOS、PC、H5 四端，主
          流应用商店均可下载，实现全场景流量触达，打通线上线下服务
          闭环。平台深度整合“餐饮、住宿、交通、游艺、零售、娱乐、
          康养、教育、商务”等核心泛文旅资源，打破行业壁垒，与合作
          伙伴共同构建文旅融合新业态。面向平台用户，今市打造集品牌
          展示、商机动态、活动营销、供需对接、即时通讯于一体的数字
          化运营服务体系，通过精准匹配供需、高效沟通直达，为产业伙
          伴降本增效、赋能升级，携手开拓文旅融合新蓝海。
        </p>
        <!-- <p style="margin-bottom: 24px">
          会聚百业，展呈世界！我们凝心聚力、潜心深耕，致力将中设国际会展集团打造成世界会展百年名企！
        </p> -->
      </div>
      <template v-if="!isAllHistory">
        <div class="mask"></div>
        <div class="more_box" @click="getAll('history')">
          <span>查看全部</span>
          <img src="../assets/images/icon_more.png" alt="" />
        </div>
      </template>
      <!-- <img src="../assets/images/company_img.png" width="100%" /> -->
      <img src="../assets/images/company_img.jpg" width="100%" />
    </div>
    <div class="major_events" :class="isShowEvent ? 'events' : ''">
      <h3>中设大事记</h3>
      <img src="../assets/images/major_events.jpg" width="100%" />
    </div>
    <div v-if="!isShowEvent" class="more_box" @click="getAll('event')">
      <span>查看全部</span>
      <img src="../assets/images/icon_more.png" alt="" />
    </div>
    <div class="team">
      <div class="title"><span>团队风采</span></div>
      <img src="../assets/images/team.png" width="100%" />
    </div>
    <div class="honor">
      <img src="../assets/images/honor.png" width="100%" />
    </div>
    <CompanyMore />
    <!-- 联系我们 -->
    <FooterCustom></FooterCustom>
  </div>
</template>
<script>
import CompanyMore from "@/components/home/company-more.vue";
import NavCustom from "@/components/nav-custom.vue";
import FooterCustom from "@/components/footer-custom.vue";

export default {
  name: "about-page",
  components: { CompanyMore, NavCustom, FooterCustom },
  data() {
    return {
      isShowEvent: false,
      isAllHistory: false,
    };
  },
  methods: {
    getAll(type) {
      if (type == "event") {
        this.isShowEvent = true;
      }
      if (type == "history") {
        this.isAllHistory = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#about {
  background: #f6f9ff;
  .banner {
    width: 100%;
    height: 160px;
    background: #fff url("../assets/images/bg_8.png") no-repeat;
    background-size: cover;
  }
  .history_panel {
    padding: 16px;
    background: #fff url("../assets/images/bg_7.png") no-repeat;
    background-size: 80%;
    position: relative;
    .title {
      margin-top: 20px;
      margin-bottom: 24px;
    }
    .title::after {
      content: "INTRODUCE";
    }
  }
  .mask {
    width: 100%;
    height: 73px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      #ffffff 100%
    );
    position: absolute;
    left: 0;
    bottom: 300px;
    z-index: 2;
  }
  .history_content {
    height: 400px;
    overflow: hidden;
    p {
      text-indent: 2em;
      font-size: 14px;
      color: #333333;
      margin-top: 18px;
      line-height: 26px;
    }
  }
  .history {
    height: auto !important;
  }
  .more_box {
    width: 98px;
    height: 28px;
    border-radius: 4px;
    border: 1px solid #0068b7;
    font-size: 14px;
    color: #0068b7;
    margin: 0 auto;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 18px;
      height: 18px;
    }
  }
  .major_events {
    padding: 0 16px;
    height: 590px;
    margin: 24px 0;
    margin-bottom: 12px;
    overflow: hidden;
    h3 {
      font-weight: bold;
      font-size: 18px;
      color: #0068b7;
      text-align: center;
      margin-bottom: 24px;
    }
    img {
      margin-bottom: 24px;
    }
  }
  .events {
    height: auto !important;
  }
  .honor {
    margin-bottom: 10px;
  }
  .team {
    padding: 0 16px;
    margin-bottom: 18px;
  }
  .title {
    display: flex;
    align-items: center;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #0068b7;
    position: relative;
    margin-bottom: 50px;
    span {
      position: absolute;
      z-index: 2;
    }
  }
  .title::after {
    content: "TEAM";
    position: absolute;
    font-weight: bold;
    font-size: 18px;
    color: #efefef;
    top: 1px;
    z-index: 1;
  }
  .title::before {
    content: "";
    width: 86px;
    height: 3px;
    background: #0068b7;
    position: absolute;
    top: 24px;
  }
}
</style>